module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_c('div', {
    staticClass: "col-8"
  }, [_c('div', {
    staticClass: "container-new-clean info-block center-text",
    staticStyle: {
      "margin-top": "100px"
    }
  }, [_c('i', {
    staticClass: "ion-android-checkmark-circle",
    staticStyle: {
      "font-size": "60px",
      "color": "#008ce8",
      "line-height": "0px",
      "margin-right": "0px"
    }
  }), _vm._v(" "), _c('h2', [_vm._v("Dziękujemy za złożenie zamówienia!")]), _vm._v(" "), _vm._m(0), _vm._v(" "), _c('b', {
    staticStyle: {
      "color": "#ff3f00"
    }
  }, [_vm._v("Link do płatności:")]), _vm._v(" "), _c('div', {
    staticClass: "ui input"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.payuUrl),
      expression: "payuUrl"
    }],
    attrs: {
      "type": "text"
    },
    domProps: {
      "value": (_vm.payuUrl)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.payuUrl = $event.target.value
      }
    }
  })])])])])
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('p', [_vm._v("Wkrótce otrzymasz mail potwierdzający, wraz z linkiem do płatności online."), _c('br'), _vm._v("W przypadku ewentualnych problemów skontaktuj się z nami: "), _c('a', {
    attrs: {
      "href": "mailto:callcenter@dts.pl"
    }
  }, [_vm._v("callcenter@dts.pl")]), _c('br'), _vm._v("Dziękujemy i życzymy miłego dnia!")])
}]}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-215f0eb2","hasScoped":false}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/FinalStep.vue
// module id = 246
// module chunks = 1